interface Image {
  width: number;
  height: number;
  src?: string;
  url?: string;
  alt: string;
}

export const url = (imageData: Image): string => {
  const output = new URL(imageData.src ?? imageData.url, `https://${Shopify.cdnHost}`);

  output.searchParams.append('width', '{width}');
  output.searchParams.append('height', '{height}');
  output.searchParams.append('crop', 'center');
  output.searchParams.sort();

  return decodeURI(output.toString());
};

export const image = (data: Image, aspect?: number): string => `
  <img
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    data-src="${url(data)}"
    data-aspectratio="${aspect ?? ''}"
    data-sizes="auto"
    data-max-width="${data.width}"
    data-max-height="${data.height}"
    alt="${data.alt ?? ''}"
    class="lazyload"
    decoding="async"
  >
`;

export const source = (imageData: Image, media: string, aspect?: number): string => `
  <source
    data-src="${url(imageData)}"
    data-aspectratio="${aspect ?? ''}"
    media="(min-width: ${media})"
  >
`;

export default {
  image,
  source,
  url,
};
